module.exports = __webpack_public_path__ + "img/circuit-veteran-2.44dc1263.png";